const map = {
	"./1/riazi/Mahdi-Aliabadi/Lesson1.jsx": [
		9632,
		[
			9632
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson2.jsx": [
		920,
		[
			920
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson3.jsx": [
		5181,
		[
			5181
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson4.jsx": [
		6858,
		[
			6858
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson5.jsx": [
		8263,
		[
			8263
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson6.jsx": [
		2076,
		[
			2076
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson7.jsx": [
		4129,
		[
			4129
		]
	],
	"./1/riazi/Mahdi-Aliabadi/Lesson8.jsx": [
		5390,
		[
			5390
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9328;
module.exports = webpackAsyncContext;